import * as API from '@siloreal:shared:api';

const SILOBAG_PRODUCT_LIST_ENDPOINT = '/silobagsProductTypes';

export type SilobagProductListServiceContract = {
  signal?: AbortSignal;
};

export async function listSilobagProductsService(
  contract: SilobagProductListServiceContract = {}
): Promise<SilobagProductListResponse> {
  const { data } = await API.http.fetch.get<SilobagProductListApiResponse>(SILOBAG_PRODUCT_LIST_ENDPOINT, {
    signal: contract.signal,
  });

  return toSilobagProductListResponse(data);
}

export type SilobagProductListResponse = SilobagProductListItem[];

type SilobagProductListApiResponse = SilobagProductListResponse | string;

export type SilobagProductListItem = {
  id: number;
  name: string;
  active: boolean;
  created_at: Date | string;
  updated_at: Date | string | null;
  language_id: number;
};

function toSilobagProductListResponse(data: SilobagProductListApiResponse): SilobagProductListResponse {
  const normalizedData = typeof data === 'string' ? JSON.parse(data) : data;

  return Array.isArray(normalizedData) ? (normalizedData as SilobagProductListResponse) : [];
}
